/* 
Allows for inline text links to trigger vue modals with any content
*/

import Vue from 'vue/dist/vue.min.js';
import VModal from 'vue-js-modal';
import {genericModal} from './modals';

Vue.use(VModal);

const genericModals = () => {
    let instance = new Vue({
        methods: {
            triggerModal(content) {
                this.$modal.show(
                    genericModal.template(content),
                    genericModal.name, 
                    genericModal.options,
                    genericModal.events
                )
            }
        },
    });

    let modalData = [];

    document.querySelectorAll('.gen-modal').forEach((item) => {
        let data = {
            "hashtag": item.dataset.hashtag,
            "content": item.innerHTML
        }
        modalData.push(data);
    });

    if (modalData) {
        document.addEventListener('click', (e) => {
            if (e.target.getAttribute('href')) {
                let target = e.target.getAttribute('href');
    
                for (let i=0; i < modalData.length; i++) {
                    if (target.includes(`#${modalData[i].hashtag}`)) {
                        e.preventDefault();
    
                        instance.triggerModal(modalData[i].content);
                        return false;
                    } 
                }
            }
        });
    }
}

export default genericModals;